import UltMeta, { Meta } from "@/meta/UltMeta/index";

class ProjectState extends UltMeta {
    STAY_ASSIGN = new Meta(1, "待指派"); // 小程序对应 待处理
    PENDING = new Meta(2, "待处理"); // 小程序对应 处理中
    PROCESSING = new Meta(3, "交付中"); // 小程序对应 交付中
    DRAFT = new Meta(4, "草稿"); // 小程序对应 草稿
    FINISHED = new Meta(5, "已完成", "color-info"); // 小程序对应 已完成
    CLOSED = new Meta(6, "已关闭", "color-info"); // 小程序对应 已关闭
}

export const PROJECT_STATE = new ProjectState();

class ProjectTabItems extends UltMeta {
    PROJECT_INFO = new Meta(1, "项目信息");
    CONTRACT_INFO = new Meta(2, "合同信息", "ContractInfo");
    PAYMENT_INFO = new Meta(3, "付款明细", "PaymentInfo");
    DELIVERY_INFO = new Meta(4, "提货申请", "DeliveryInfo");
    SIGN_INFO = new Meta(5, "签收明细", "ReceiptInfo");
    RECONCILIATION_INFO = new Meta(6, "对账明细", "ReconciliationInfo");
    SERVICE_COST_INFO = new Meta(7, "服务费明细", "ServiceCostBillDetail");
    BILLING_INFO = new Meta(8, "开票明细", "InvoiceInfo");
}

export const PROJECT_TAB_ITEMS = new ProjectTabItems();

class ProjectType extends UltMeta {
    ONLINE = new Meta(1, "线上");
    OFFLINE = new Meta(2, "线下");
}

export const PROJECT_TYPE = new ProjectType();

class ServiceCostState extends UltMeta {
    UNSETTLED = new Meta(1, "未结算");
    SETTLED = new Meta(2, "已结算");
    AUTO_SETTLED = new Meta(3, "自动结算");
}

export const SERVICE_COST_STATE = new ServiceCostState();

class ProTableCardType extends UltMeta {
    ONE = new Meta(1, "供应联合采购商关联提货单");
    TWO = new Meta(2, "联合购销商采购商关联签收单");
    THREE = new Meta(3, "对账关联签收单");
}

export const PRO_TABLE_CARD_TYPE = new ProTableCardType();
